const VGONG_SCROLL_HEIGHT_PX = 250;
const MATCH_SCROLL_HEIGHT_PX = 200;

const addScrollClassIfNeeded = ($container, heightPx) => {
	if (!$container.length) {
		return;
	}

	const height = Math.round($container.height());

	if (height >= heightPx) {
		$container.addClass("scroll");
	}
};

const initOddsCards = () => {
	addScrollClassIfNeeded(window.jQuery(".odds-vgong"), VGONG_SCROLL_HEIGHT_PX);
	addScrollClassIfNeeded(window.jQuery(".odds-match"), MATCH_SCROLL_HEIGHT_PX);
};

window.jQuery(initOddsCards);
